export default __webpack_public_path__ + "static/media/light_tag.e2af5f0d.svg";